import bootstrap from '../node_modules/bootstrap/dist/js/bootstrap';

// カスタムスタイルシートの読み込み
import './custom.scss';
//lazysizes と ls.unveilhooks（プラグイン）の読み込み
import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
//Swiper スライダープラグイン
import Swiper from 'swiper/bundle';
//Swiper styles 
import 'swiper/css/bundle';
//rellax.js パララックスプラグイン
import 'rellax';

//Luminous lightbox プラグイン
import { Luminous, LuminousGallery } from 'luminous-lightbox';
import 'luminous-lightbox/dist/luminous-basic.min.css';

//figcaption または alt 属性の値をキャプションに表示
const luminousOpts = {
  caption: (trigger) => {   
    const elemsArray =  Array.prototype.slice.call( document.querySelectorAll('.' + trigger.className) ) ;
    const total = elemsArray.length;
    const index = elemsArray.indexOf( trigger ) + 1 ;
    const figCaption = trigger.parentElement.querySelector('figcaption');
    if(figCaption !== null && figCaption.textContent !== '') {
      if(total > 1) {
        return figCaption.textContent + '<span class="fraction">' + index + ' / ' + total + '</span>';
      }else{
        return figCaption.textContent;
      }
    }else{
      if(trigger.querySelector('img').hasAttribute('alt')) {
        if(total > 1) {
          return trigger.querySelector('img').getAttribute('alt') + '<span class="fraction">' + index + ' / ' + total + '</span>';
        }else{
          return trigger.querySelector('img').getAttribute('alt');
        } 
      }else{
        if(total > 1) {
          return index + ' / ' + total ;
        }else{
          return '';
        } 
      }
    }
  },
}

//ページに .luminous が複数ある場合は、ギャラリー表示、1つだけの場合は単体表示するライトボックスの初期化
const luminousElems = document.querySelectorAll('.luminous');
if( luminousElems !== null ) {
  if( luminousElems.length > 1 ) {
    new LuminousGallery(luminousElems, {}, luminousOpts);
  }else if(luminousElems[0]){
    new Luminous(luminousElems[0], luminousOpts);
  }
}
//単体として表示する Luminous lightbox（ギャラリー表示なし：前後の矢印なし）
const lumiSolosOpts = {
  caption: (trigger) => {
    const figCaption = trigger.parentElement.querySelector('figcaption');
    if(figCaption !== null && figCaption.textContent !== '') {
      return figCaption.textContent;
    }else{
      if(trigger.querySelector('img').hasAttribute('alt')) {
        return trigger.querySelector('img').getAttribute('alt');
      }else{
        return '';
      }
    }
  },
}
//ページに .lumi-solo が複数ある場合でも、単体表示するライトボックスの初期化
const lumiSoloElems = document.querySelectorAll('.lumi-solo');
if( lumiSoloElems !== null ) {
  lumiSoloElems.forEach( (elem) => {
    new Luminous(elem, lumiSolosOpts);
  });
}
//.lumix1 〜 .lumix5
for(let i=1; i<6; i++) {
  let luminousOptsX =  'luminousOptsX' + i;
  luminousOptsX = {
    caption: (trigger) => {   
      const elemsArray =  Array.prototype.slice.call( document.querySelectorAll('.' + trigger.className) ) ;
      const total = elemsArray.length;
      const index = elemsArray.indexOf( trigger ) + 1 ;
      const captionElem = trigger.parentElement.querySelector('.caption');
      const figCaption = trigger.parentElement.querySelector('figcaption');
      if(captionElem !== null && captionElem.textContent !== '') {
        if(total > 1) {
          return captionElem.textContent + '<span class="fraction">' + index + ' / ' + total + '</span>';
        }else{
          return captionElem.textContent;
        }
      }else if(figCaption !== null && figCaption.textContent !== '') {
        if(total > 1) {
          return figCaption.textContent + '<span class="fraction">' + index + ' / ' + total + '</span>';
        }else{
          return figCaption.textContent;
        }
      }else{
        if(trigger.querySelector('img').hasAttribute('alt')) {
          if(total > 1) {
            return trigger.querySelector('img').getAttribute('alt') + '<span class="fraction">' + index + ' / ' + total + '</span>';
          }else{
            return trigger.querySelector('img').getAttribute('alt');
          } 
        }else{
          if(total > 1) {
            return index + ' / ' + total ;
          }else{
            return '';
          } 
        }
      }
    },
  } 
  const luminousClass =  '.lumix' + i;
  let luminousGalleries = document.querySelectorAll(luminousClass);
  if( luminousGalleries.length > 0 ) {
    new LuminousGallery(luminousGalleries, {}, luminousOptsX);
  }
} 
//bootstrap tooltip
var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new bootstrap.Tooltip(tooltipTriggerEl)
})
//ontouchstart
document.body.setAttribute("ontouchstart", "");

//Bootstrap Light Box
const lightbox_class = 'bs-lbox';  //画像へのリンク（a 要素）に指定するクラス
const modal_id = 'bs-lbox-dialog'; //モーダルの要素に指定する ID
const modal_id_hash = '#' + modal_id; //ID の前に # を付けた値
//「閉じる」ボタンにインラインで指定するスタイル
//const button_style = 'style="background-color: #fff; border-radius: 50%;"';
const button_style = '';
//閉じるの「ｘ」にインラインで指定するスタイル
const span_style = '';
//モーダルのサイズを指定（modal-sm/modal-lg/modal-xl/''）
const size = 'modal-lg'; 
//lightbox_class クラスの指定された要素
const lb_elems = document.getElementsByClassName(lightbox_class);

if(lb_elems.length > 0 ) {
  let div = document.createElement('div');
  div.id = modal_id;
  div.role = "dialog";
  div.setAttribute('class', 'modal fade');
  div.setAttribute('id', modal_id);
  div.setAttribute('role', 'dialog');
  div.setAttribute('aria-hidden', 'true');
  div.innerHTML = '<div class="modal-dialog modal-dialog-centered ' + size + '" role="img"><div class="modal-content" style="background-color: transparent; border: none;"><div class="btn-close2" data-bs-dismiss="modal" aria-label="Close" ' + button_style + '></div><img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" alt=""> </div></div>';
  document.body.appendChild(div);
  Array.prototype.forEach.call(lb_elems, function (elem, index) {
    elem.setAttribute('data-bs-target', modal_id_hash);
    elem.setAttribute('data-bs-toggle',  'modal');
  }); 
  const modal_elem = document.getElementById(modal_id);
  modal_elem.addEventListener('show.bs.modal', function(event) {
    let image_link = event.relatedTarget;
    let href = image_link.getAttribute('href');
    modal_elem.getElementsByTagName('img')[0].setAttribute('src',href );
    //横長の画像の場合はモーダルのサイズのクラスを modal-xl に変更
    let image_link_class = image_link.classList;
    if(image_link_class.contains('landscape')) {
      modal_elem.getElementsByClassName('modal-lg')[0].classList.replace('modal-lg', 'modal-xl')
    }
  });
}

// toggle navbar & top image animation class
const scrollToTopBtn = document.getElementById('scroll-to-top');

if(scrollToTopBtn) {
  window.addEventListener('scroll', () => {
    const scrollTop = document.scrollingElement.scrollTop;
    if(scrollToTopBtn) {
      if (scrollTop > 500) {
        scrollToTopBtn.classList.add('scrolled');
      } else {
        scrollToTopBtn.classList.remove('scrolled');
      }
    }
  }); 

  scrollToTopBtn.addEventListener('click', () =>{
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
}

//SPAM
const nsm_elems = document.getElementsByClassName('nsm');
if(nsm_elems.length !== 0) {
  let delimiter = ","; 
  Array.prototype.forEach.call(nsm_elems, function (elem, index) {
    //alert (index + ' : ' + elem.textContent );
    let nsm_strings = elem.textContent.split(delimiter);  //分割文字で分割
    //alert(nsm_strings.length);
    nsm_strings = nsm_strings.map(function(nsm_string) {
      return nsm_string.trim();//分割した文字列から前後の空白を削除
    });
    //alert(nsm_strings);
    let pre = nsm_strings[0];  //アドレスの＠マークの前の文字列
    let domain = "&#64;" + nsm_strings[1];  
    //@（&#64;）と後ろの部分を連結
    let nsm_address =  pre + domain;    //メールアドレスを組み立てる
    let addressWithSubject = nsm_address;
    if(nsm_strings[2]){    //表題が指定されていれば
      addressWithSubject += "?subject=" + nsm_strings[2];
    }
    if(nsm_strings[3]){   //表示する文字が指定されていれば
      elem.innerHTML = '<a href="ma' + 'ilto:' + addressWithSubject + '">'  +  nsm_strings[3] + '</a>';
    }else{
      elem.innerHTML = '<a href="ma' + 'ilto:' + addressWithSubject + '">'  +  nsm_address + '</a>';
    }   
  });   
}

//Swiper の設定を data-* 属性に指定するようにする
const sliderElems = document.querySelectorAll('.swiper:not(.thumbs-slider, .main-slider)');
if(sliderElems && sliderElems.length > 0) {
  for ( let element of sliderElems ) {
    let elementSpeed = element.getAttribute('data-speed'),
        elementDirection = element.getAttribute('data-direction'),
        elementAutoPlay = element.getAttribute('data-autoplay'),
        elementLoop = element.getAttribute('data-loop'),  
        elementEffect = element.getAttribute('data-effect'),
        elementSlidesPerView = element.getAttribute('data-slides-per-view'),
        elementSlidesPerGroup = element.getAttribute('data-slides-per-group'),
        elementSpaceBetween = element.getAttribute('data-space-between'), 
        elementCenteredSlides = element.getAttribute('data-centered-slides'),  
        elementLoadPrevNext = element.getAttribute('data-load-prev-next'),  
        elementStopAtFirstSlide =  element.getAttribute('data-stop-at-first-slide'), 
        elementLazyLoad = false,
        slidePreloadImages = true;
    let swiperLazyElems = element.querySelectorAll('.swiper-lazy');
    if(swiperLazyElems && swiperLazyElems.length !==0 ) {
       elementLazyLoad = true;
    }
    if(elementLazyLoad) {
      if (elementLoadPrevNext === 'true') {
        elementLoadPrevNext = true;
      } else {
        elementLoadPrevNext = false;
      }
      elementLazyLoad = elementLoadPrevNext ?  { loadPrevNext: true,} : true;
      slidePreloadImages = false;
    }
    if (!elementSpeed) {
      elementSpeed = 300;
    }
    if (!elementDirection) {
      elementDirection = 'horizontal';
    }
    if (elementAutoPlay) {
      elementAutoPlay = parseInt(elementAutoPlay);
    } else {
      elementAutoPlay = 999999999;
    }
    if (elementLoop === 'true') {
      elementLoop = true;
    } else {
      elementLoop = false;
    }
    if (!elementEffect) {
      elementEffect = 'slide';
    }
    if (!elementSlidesPerView) {
      elementSlidesPerView = 1;
    }
    if (elementCenteredSlides === 'true') {
      elementCenteredSlides = true;
    } else {
      elementCenteredSlides = false;
    }
    if (!elementSlidesPerGroup) {
      elementSlidesPerGroup = 1;
    }
    if (!elementSpaceBetween) {
      elementSpaceBetween = 0;
    }
    let mySwiper = new Swiper(element, {
      direction: elementDirection,
      speed: parseInt(elementSpeed),
      autoplay: {
        delay: elementAutoPlay
      },
      loop: elementLoop,
      effect: elementEffect,
      slidesPerView: parseFloat(elementSlidesPerView),
      centeredSlides: elementCenteredSlides,
      slidesPerGroup: parseInt(elementSlidesPerGroup),
      spaceBetween: parseInt(elementSpaceBetween),
      preloadImages: slidePreloadImages,
      lazy: elementLazyLoad,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      scrollbar: {
        el: '.swiper-scrollbar',
      },
    });
    
    if (elementStopAtFirstSlide === 'true') {
      elementStopAtFirstSlide = true;
    } else {
      elementStopAtFirstSlide = false;
    }
    if(elementAutoPlay !== 999999999 && elementStopAtFirstSlide) {
      mySwiper.on('reachEnd', function () {
        this.autoplay.stop();
      });
    }
    /*const slide_img_elems = document.getElementsByClassName('swiper-lazy');
    if(slide_img_elems.length>0) {
      const slide_img_bg_src = [];
      for (let elem of slide_img_elems) {
        slide_img_bg_src.push(elem.getAttribute('data-background'));
      }
      let setupActiveSlide = true;
      let timer = false; 
      window.addEventListener('resize', ()=> { 
        if(setupActiveSlide) {
          const activeSlide = document.querySelector('.swiper-slide-active');
          activeSlide.style.setProperty('background-image', 'url("' + slide_img_bg_src[mySwiper.activeIndex] + '")');
          activeSlide.style.setProperty('background-size', 'cover');
          activeSlide.style.setProperty('background-position', 'center center');
          setupActiveSlide = false;
        }
        if (timer !== false) {
          clearTimeout(timer);
        }
        timer = setTimeout( () => {
          const img_loaded = document.getElementsByClassName('swiper-lazy-loaded');   
          for (let i=0; i < img_loaded.length; i++) { 
            if(mySwiper.params.loop) {
              let slide_index = parseInt(img_loaded[i].parentElement.getAttribute('data-swiper-slide-index')) + 1;
              img_loaded[i].style.setProperty('background-image', 'url("' + slide_img_bg_src[slide_index] + '")');
            }else{
              img_loaded[i].style.setProperty('background-image', 'url("' + slide_img_bg_src[i] + '")');
            } 
            setupActiveSlide= true;
          }
        }, 200);
      }); 
    }*/
  }
}
const mainSliders = document.getElementsByClassName('main-slider');
const thumbsSliders = document.getElementsByClassName('thumbs-slider');
const mySwiperThumbsArray = [];
if(mainSliders && thumbsSliders && mainSliders.length > 0 && thumbsSliders.length > 0 && mainSliders.length === thumbsSliders.length) {
  for ( let i=0; i<thumbsSliders.length; i++ ) {
    let dataSpeed = thumbsSliders[i].getAttribute('data-speed'),
        dataDirection = thumbsSliders[i].getAttribute('data-direction'),
        dataAutoPlay = thumbsSliders[i].getAttribute('data-autoplay'),
        dataLoop = thumbsSliders[i].getAttribute('data-loop'),
        dataEffect = thumbsSliders[i].getAttribute('data-effect'),
        dataSlidesPerView = thumbsSliders[i].getAttribute('data-slides-per-view'),
        dataSlidesPerGroup = thumbsSliders[i].getAttribute('data-slides-per-group'),
        dataSpaceBetween = thumbsSliders[i].getAttribute('data-space-between'), 
        dataCenteredSlides = thumbsSliders[i].getAttribute('data-centered-slides');
    if (!dataSpeed) {
      dataSpeed = 300;
    }
    if (!dataDirection) {
      dataDirection = 'horizontal';
    }
    if (dataAutoPlay) {
      dataAutoPlay = parseInt(dataAutoPlay);
    } else {
      dataAutoPlay = 999999999;
    }
    if (dataLoop === 'true') {
      dataLoop = true;
    } else {
      dataLoop = false;
    }
    if (!dataEffect) {
      dataEffect = 'slide';
    }
    if (!dataSlidesPerView) {
      dataSlidesPerView = 4;
    }
    if (dataCenteredSlides === 'true') {
      dataCenteredSlides = true;
    } else {
      dataCenteredSlides = false;
    }
    if (!dataSlidesPerGroup) {
      dataSlidesPerGroup = 1;
    }
    if (!dataSpaceBetween) {
      dataSpaceBetween = 0;
    }
    let mySwiperThumbs = new Swiper(thumbsSliders[i], {
      direction: dataDirection,
      speed: parseInt(dataSpeed),
      autoplay: {
        delay: dataAutoPlay
      },
      loop: dataLoop,
      effect: dataEffect,
      slidesPerView: parseFloat(dataSlidesPerView),
      centeredSlides: dataCenteredSlides,
      slidesPerGroup: parseInt(dataSlidesPerGroup),
      spaceBetween: parseInt(dataSpaceBetween),
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      grabCursor: true,
    });
    mySwiperThumbsArray.push(mySwiperThumbs);
  }
  for ( let i=0; i<mainSliders.length; i++ ) {
    let mainDataSpeed = mainSliders[i].getAttribute('data-speed'),
        mainDataDirection = mainSliders[i].getAttribute('data-direction'),
        mainDataAutoPlay = mainSliders[i].getAttribute('data-autoplay'),
        mainDataLoop = mainSliders[i].getAttribute('data-loop'),
        mainDataEffect = mainSliders[i].getAttribute('data-effect'),
        mainDataSlidesPerView = mainSliders[i].getAttribute('data-slides-per-view'),
        mainDataSlidesPerGroup = mainSliders[i].getAttribute('data-slides-per-group'),
        mainDataSpaceBetween = mainSliders[i].getAttribute('data-space-between'), 
        mainDataCenteredSlides = mainSliders[i].getAttribute('data-centered-slides');
    if (!mainDataSpeed) {
      mainDataSpeed = 300;
    }
    if (!mainDataDirection) {
      mainDataDirection = 'horizontal';
    }
    if (mainDataAutoPlay) {
      mainDataAutoPlay = parseInt(mainDataAutoPlay);
    } else {
      mainDataAutoPlay = 999999999;
    }
    if (mainDataLoop === 'true') {
      mainDataLoop = true;
    } else {
      mainDataLoop = false;
    }
    if (!mainDataEffect) {
      mainDataEffect = 'slide';
    }
    if (!mainDataSlidesPerView) {
      mainDataSlidesPerView = 1;
    }
    if (mainDataCenteredSlides === 'true') {
      mainDataCenteredSlides = true;
    } else {
      mainDataCenteredSlides = false;
    }
    if (!mainDataSlidesPerGroup) {
      mainDataSlidesPerGroup = 1;
    }
    if (!mainDataSpaceBetween) {
      mainDataSpaceBetween = 0;
    }
    let mySwiperMain = new Swiper(mainSliders[i], {
      direction: mainDataDirection,
      speed: parseInt(mainDataSpeed),
      autoplay: {
        delay: mainDataAutoPlay
      },
      loop: mainDataLoop,
      effect: mainDataEffect,
      slidesPerView: parseFloat(mainDataSlidesPerView),
      centeredSlides: mainDataCenteredSlides,
      slidesPerGroup: parseInt(mainDataSlidesPerGroup),
      spaceBetween: parseInt(mainDataSpaceBetween),
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      thumbs: {
        swiper: mySwiperThumbsArray[i]
      },
    });
  }
}

//パララックスプラグイン Rellax.js
const rellaxElems = document.querySelectorAll('.rellax');
if(rellaxElems && rellaxElems.length > 0) {
  //Rellax を定義
  const Rellax = require('rellax');
  //Rellax の初期化
  var rellax = new Rellax('.rellax', {
    speed: -6,
    center: false,
    wrapper: null,
    round: true,
    vertical: true,
    horizontal: false,
    breakpoints:[576, 768, 992]
  });
}

//Lazyloading 対応（loading 属性がサポートされていれば data-src の値を src に設定）
if ('loading' in HTMLImageElement.prototype) { 
  //loading 属性に lazy が指定されている img 要素
  const images = document.querySelectorAll('img[loading="lazy"]');
  //data-srcset が指定されている img 要素
  const img_srcset = document.querySelectorAll("img[data-srcset]");
  //data-srcset が指定されている source 要素
  const sources = document.querySelectorAll("source[data-srcset]");
 
  //loading="lazy" が設定されている要素があれば
  if(images.length > 0) {
    images.forEach(img => {
    //data-src 属性が設定されていれば img 要素の src 属性の値に data-src 属性の値を設定
      if(img.dataset.src) {
         img.src = img.dataset.src;
      }
    });
  }
  //data-srcset が指定されている img 要素があれば
  if(img_srcset.length > 0) {
    img_srcset.forEach(img_srcset => {
      //img 要素の srcset 属性の値に data-srcset 属性の値を設定
      img_srcset.srcset = img_srcset.dataset.srcset;
    });
  }
  //picture 要素
  //data-srcset が指定されている source 要素があれば
  if(sources.length > 0){
    sources.forEach(source => {
      //source 要素の srcset 属性の値に data-srcset 属性の値を設定
      source.srcset = source.dataset.srcset;
    });
  }
}
//フォーム検証
const validationForm = document.getElementsByClassName('validationForm')[0];
if(validationForm) {
  let validateAfterFirstSubmit = true;
  const errorClassName = 'error';
  const preLabel = '「';
  const postLabel = '」';
  const requiredMsg = '入力は必須です';
  const requiredMsg_L = 'は必須です';
  const requiredSelectMsg = '選択してください';
  const requiredSelectMsg_L = 'を選択してください';  
  const requiredCheckboxMsg = '選択は必須です';
  const requiredCheckboxMsg_L = 'の選択は必須です'; 
  const requiredRadioMsg = '選択は必須です';
  const requiredRadioMsg_L = 'の選択は必須です';
  const patternMsg = '入力された値が正しくないようです';
  const patternMsg_L = 'の形式が正しくないようです';
  const minlengthMsg = '文字以上で入力ください';
  const minlengthMsg_L1 = 'は' ;
  const minlengthMsg_L2 = '文字以上で入力ください';
  const maxlengthMsg = '文字以内で入力ください';
  const maxlengthMsg_L1 = 'は' ;
  const maxlengthMsg_L2 = '文字以内で入力ください';
  const minMsg = '以上の値を入力ください';
  const minMsg_L1 = 'は' ;
  const minMsg_L2 = '以上の値を入力ください';
  const maxMsg = '以下の値を入力ください';
  const maxMsg_L1 = 'は' ;
  const maxMsg_L2 = '以下の値を入力ください';
  const equalToMsg = '入力された値が異なります';
  const equalToMsg_L = 'に入力された値が異なります'; 

  const emailRegExp = /^([a-z0-9\+_\-]+)(\.[a-z0-9\+_\-]+)*@([a-z0-9\-]+\.)+[a-z]{2,6}$/ui;
  const telRegExp = /^\(?\d{2,5}\)?[-(\.\s]{0,2}\d{1,4}[-)\.\s]{0,2}\d{3,4}$/;
  const zipRegExp = /^\d{3}-{0,1}\d{4}$/;
  const hiraganaRegExp = /^[\u3041-\u3096\u30FC]+$/;
  const katakanaRegExp = /^[\u30A1-\u30FC]+$/;
  const hankataRegExp = /^[\uFF61-\uFF9F]+$/;
  const patternMap = new Map([
    ['email', emailRegExp], 
    ['tel', telRegExp], 
    ['zip', zipRegExp],
    ['hiragana', hiraganaRegExp],
    ['katakana', katakanaRegExp],
    ['hankata', hankataRegExp],
  ]); 

  const requiredElems = document.querySelectorAll('.required');
  const patternElems =  document.querySelectorAll('.pattern');
  const minlengthElems =  document.querySelectorAll('.minlength');
  const maxlengthElems =  document.querySelectorAll('.maxlength');
  const minElems =  document.querySelectorAll('.min');
  const maxElems =  document.querySelectorAll('.max');
  const showCountElems =  document.querySelectorAll('.showCount');
  const togglers = document.querySelectorAll('.toggler'); 
  const togglerTargets = [];
  const equalToElems = document.querySelectorAll('.equal-to'); 

  const addError = (elem, className, defaultMessage, labelMessage) => {
    let errorMessage = defaultMessage;
    if(elem.hasAttribute('data-error-' + className)) { 
      const dataError = elem.getAttribute('data-error-' + className);
      if(dataError === 'label') {
        if(elem.parentElement.querySelector('label')) {
          const label = elem.parentElement.querySelector('label').textContent;
          if(label) {
            errorMessage = preLabel + label + postLabel + labelMessage;
          }
        }
      }else if(dataError) {
        errorMessage = dataError;
      }
    }
    if(!validateAfterFirstSubmit) {
      const errorSpan = document.createElement('span');
      errorSpan.classList.add(errorClassName, className);
      errorSpan.setAttribute('aria-live', 'polite');
      errorSpan.textContent = errorMessage;
      elem.parentNode.appendChild(errorSpan);
    }
  }

  const isValueMissing = (elem) => {
    if(elem.tagName === 'INPUT' && elem.getAttribute('type') === 'radio') {
      const className = 'required-radio';
      const errorSpan = elem.parentElement.querySelector('.' + errorClassName + '.' + className);
      const checkedRadio = elem.parentElement.querySelector('input[type="radio"]:checked');
      if(checkedRadio === null) {
       if(!errorSpan) {
          addError(elem, className, requiredRadioMsg, requiredRadioMsg_L);
        }
        return true;
      } else{
        if(errorSpan) {
          elem.parentNode.removeChild(errorSpan);
        }
        return false;
      } 
    }else if(elem.tagName === 'INPUT' && elem.getAttribute('type') === 'checkbox') {
      const className = 'required-checkbox';
      const errorSpan = elem.parentElement.querySelector('.' + errorClassName + '.' + className);
      const checkedCheckbox = elem.parentElement.querySelector('input[type="checkbox"]:checked');
      if(checkedCheckbox === null) {
        if(!errorSpan) {
          addError(elem, className, requiredCheckboxMsg, requiredCheckboxMsg_L);
        }
        return true;
      }else{
        if(errorSpan) {
          elem.parentNode.removeChild(errorSpan);
        }
        return false;
      }
    }else{
      const className = 'required';
      const errorSpan = elem.parentElement.querySelector('.' + errorClassName + '.' + className);
      if(elem.value.trim().length === 0) {
        if(!errorSpan) {
          if(elem.tagName === 'SELECT') {
            addError(elem, className, requiredSelectMsg, requiredSelectMsg_L);
          }else{ 
            addError(elem, className, requiredMsg, requiredMsg_L);
          } 
        }
        return true;
      }else{
        if(errorSpan) {
          elem.parentNode.removeChild(errorSpan);
        }
        return false;
      }
    }
  }

  requiredElems.forEach( (elem) => {
    if(elem.tagName === 'INPUT' && (elem.getAttribute('type') === 'radio' || elem.getAttribute('type') === 'checkbox' )){
      const elems = elem.parentElement.querySelectorAll(elem.tagName);
      elems.forEach( (elemsChild) => {
        elemsChild.addEventListener('change', () => {
          isValueMissing(elemsChild);
        });
      });
    }else{
      elem.addEventListener('input', () => {
        isValueMissing(elem);
      });
    }
  });

  const isPatternMismatch = (elem) => {
    const className = 'pattern';
    const attributeName = 'data-' + className;
    let pattern = new RegExp('^' + elem.getAttribute(attributeName) + '$');
    patternMap.forEach((value, key) => {
      if(elem.getAttribute(attributeName) === key) {
        pattern = value;
      }
    });
    const errorSpan = elem.parentElement.querySelector('.' + errorClassName + '.' + className);
    if(elem.value.trim() !=='') {
      if(!pattern.test(elem.value)) {
        if(!errorSpan) {
          addError(elem, className, patternMsg, patternMsg_L);
        }
        return true;
      }else{
        if(errorSpan) {
          elem.parentNode.removeChild(errorSpan);
        }
        return false;
      }
    }else if(elem.value ==='' && errorSpan) {
      elem.parentNode.removeChild(errorSpan);
    }
  }

  patternElems.forEach( (elem) => {
    elem.addEventListener('input', () => {
      isPatternMismatch(elem);
    })
  }); 

  const getValueLength = (value) => {
    return (value.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]|[\s\S]/g) || []).length;
  }

  const isTooShort = (elem) => {
    const className = 'minlength';
    const attributeName = 'data-' + className;
    const minlength = elem.getAttribute(attributeName);
    const errorSpan = elem.parentElement.querySelector('.' + errorClassName + '.' + className);
    if(elem.value !=='') {
      const valueLength = getValueLength(elem.value);
      if(valueLength < minlength) {
        if(!errorSpan) {
          addError(elem, className, minlength + minlengthMsg, minlengthMsg_L1 + minlength + minlengthMsg_L2);
        }
        return true;
      }else{
        if(errorSpan) {
          elem.parentNode.removeChild(errorSpan);
        }
        return false;
      }
    }else if(elem.value ==='' && errorSpan) {
      elem.parentNode.removeChild(errorSpan);
    }
  }

  minlengthElems.forEach( (elem) => {
    elem.addEventListener('input', () => {
      isTooShort(elem);
    })
  }); 

  const isTooLong = (elem) => {
    const className = 'maxlength';
    const attributeName = 'data-' + className;
    const maxlength = elem.getAttribute(attributeName);
    const errorSpan = elem.parentElement.querySelector('.' + errorClassName + '.' + className);
    if(elem.value !=='') {
      const valueLength = getValueLength(elem.value);
      if(valueLength > maxlength) {
        if(!errorSpan) {
          addError(elem, className, maxlength + maxlengthMsg, maxlengthMsg_L1 +  maxlength + maxlengthMsg_L2);
        }
        return true;
      }else{
        if(errorSpan) {
          elem.parentNode.removeChild(errorSpan);
        }
        return false;
      }
    }else if(elem.value ==='' && errorSpan) {
      elem.parentNode.removeChild(errorSpan);
    }
  }

  maxlengthElems.forEach( (elem) => {
    elem.addEventListener('input', () => {
      isTooLong(elem);
    })
  }); 

  const isRangeUnderflow = (elem) => {
    const className = 'min';
    const attributeName = 'data-' + className;
    const min = parseFloat(elem.getAttribute(attributeName));
    const errorSpan = elem.parentElement.querySelector('.' + errorClassName + '.' + className);
    if(elem.value !=='') {
      const val = parseFloat(elem.value);
      if(val < min) {
        if(!errorSpan) {
          addError(elem, className, min + minMsg, minMsg_L1 + min + minMsg_L2);
        }
        return true;
      }else{
        if(errorSpan) {
          elem.parentNode.removeChild(errorSpan);
        }
        return false;
      }
    }else if(elem.value ==='' && errorSpan) {
      elem.parentNode.removeChild(errorSpan);
    }
  }

  minElems.forEach( (elem) => {
    elem.addEventListener('input', () => {
      isRangeUnderflow(elem);
    })
  }); 

  const isRangeOverflow = (elem) => {
    const className = 'max';
    const attributeName = 'data-' + className;
    const max = parseFloat(elem.getAttribute(attributeName));
    const errorSpan = elem.parentElement.querySelector('.' + errorClassName + '.' + className);
    if(elem.value !=='') {
      const val = parseFloat(elem.value); 
      if(val > max) {
        if(!errorSpan) {
          addError(elem, className, max + maxMsg, maxMsg_L1 + max + maxMsg_L2);
        }
        return true;
      }else{
        if(errorSpan) {
          elem.parentNode.removeChild(errorSpan);
        }
        return false;
      }
    }else if(elem.value ==='' && errorSpan) {
      elem.parentNode.removeChild(errorSpan);
    }
  }

  maxElems.forEach( (elem) => {
    elem.addEventListener('input', () => {
      isRangeOverflow(elem);
    })
  }); 

  for(let i=0; i<showCountElems.length; i++) {
    const dataMaxlength = showCountElems[i].getAttribute('data-maxlength');  
    if(dataMaxlength && !isNaN(dataMaxlength)) {
      const countElem = document.createElement('p');
      countElem.classList.add('countSpanWrapper');
      countElem.innerHTML = '<span class="countSpan">0</span>/' + parseInt(dataMaxlength);
      showCountElems[i].parentNode.appendChild(countElem);
    }
    showCountElems[i].addEventListener('input', (e) => {
      const countSpan = showCountElems[i].parentElement.querySelector('.countSpan');
      if(countSpan) {
        const count = getValueLength(e.currentTarget.value);
        countSpan.textContent = count;
        if(count > dataMaxlength) {
          countSpan.style.setProperty('color', 'red');
        }else{
          countSpan.style.removeProperty('color');
        } 
      } 
    });
  }

  togglers.forEach((elem) => {
    const togglerTarget = document.querySelector('#' + elem.getAttribute('data-togglerTarget'));
    togglerTarget.parentElement.style.setProperty('display', 'none');
    togglerTargets.push(togglerTarget);
  });

  const toggleTarget = (elem) => {
    const target =  document.querySelector('#' + elem.getAttribute('data-togglerTarget'));
    if(elem.type === 'checkbox') {
      if(elem.checked === true) {
       target.parentElement.style.removeProperty('display'); 
      }else{
        target.parentElement.style.setProperty('display', 'none');
      }
    }else if(elem.type === 'radio') {  
      target.parentElement.style.removeProperty('display'); 
      const radios = elem.parentElement.querySelectorAll('[type="radio"]');
      radios.forEach((elem) => {
        elem.addEventListener('change', () => {
          if(elem.className !== 'toggler') {
            if(target.parentElement.style.getPropertyValue('display') !== 'none') {
              target.parentElement.style.setProperty('display', 'none');
            } 
          }  
        }, {once: true});
      });
    } 
  }

  togglers.forEach((elem) => {
    elem.addEventListener('change', (e) => {
      toggleTarget(e.currentTarget);
    });
  });

  const isNotEqualTo = (elem) => {
    const className = 'equal-to';
    const attributeName = 'data-' + className;
    const equalTo = elem.getAttribute(attributeName);
    const equalToElem = document.getElementById(equalTo);
    const errorSpan = elem.parentElement.querySelector('.' + errorClassName + '.' + className);
    if(elem.value.trim() !=='' && equalToElem.value.trim() !=='') {
      if(equalToElem.value !== elem.value) {
        if(!errorSpan) {
          addError(elem, className, equalToMsg, equalToMsg_L);
        }
        return true;
      }else{
        if(errorSpan) {
          elem.parentNode.removeChild(errorSpan);
        }
        return false;
      }
    } 
  }

  equalToElems.forEach( (elem) => {
    elem.addEventListener('input', () => {
      isNotEqualTo(elem);
    });
    const compareTarget = document.getElementById(elem.getAttribute('data-equal-to'));
    if(compareTarget) {
      compareTarget.addEventListener('input', () => {
        isNotEqualTo(elem);
      });
    }
  });

  validationForm.addEventListener('submit', (e) => {
    validateAfterFirstSubmit = false;
    requiredElems.forEach( (elem) => {
      if(isValueMissing(elem) && elem.parentElement.style.getPropertyValue('display') !=='none') {
        e.preventDefault();
      }
    });
    patternElems.forEach( (elem) => {
      if(isPatternMismatch(elem)) {
        e.preventDefault();
      }
    });
    minlengthElems.forEach( (elem) => {
      if(isTooShort(elem)) {
        e.preventDefault();
      }
    });
    maxlengthElems.forEach( (elem) => {
      if(isTooLong(elem)) {
        e.preventDefault();
      }
    });
    minElems.forEach( (elem) => {
      if(isRangeUnderflow(elem)) {
        e.preventDefault();
      }
    });
    maxElems.forEach( (elem) => {
      if(isRangeOverflow(elem)) {
        e.preventDefault();
      }
    });
    togglerTargets.forEach( (elem) => {
      if(elem.parentElement.style.getPropertyValue('display') ==='none') {
        elem.value = '';
      }
    });
    equalToElems.forEach( (elem) => {
      if(isNotEqualTo(elem)) {
        e.preventDefault();
      }
    });

    const targetSelector = '.' + errorClassName + ':not([style*="display: none"]' + ' .' + errorClassName + ' )';
    const errorElem = document.querySelector(targetSelector);
    if(errorElem) {
      const errorElemOffsetTop = errorElem.offsetTop;
      window.scrollTo({
        top: errorElemOffsetTop - 40,
        behavior: 'smooth'
      });
    }
  });
}

//WordPress the_posts_navigation
const navPrevA = document.querySelector('.nav-previous a'); 
if(navPrevA) {
  let navPrevAClass = navPrevA.classList;
  navPrevAClass.add('btn');
  //navPrevAClass.add('btn-outline-success');
  navPrevAClass.add('btn-outline-green-title');
}
const navNextA = document.querySelector('.nav-next a'); 
if(navNextA) {
  let navNextAClass = navNextA.classList;
  navNextAClass.add('btn');
  //navNextAClass.add('btn-outline-success');
  navNextAClass.add('btn-outline-green-title');
}